import { render, staticRenderFns } from "./PageSectionListView.vue?vue&type=template&id=0ca48b74&scoped=true"
import script from "./PageSectionListView.vue?vue&type=script&lang=js"
export * from "./PageSectionListView.vue?vue&type=script&lang=js"
import style0 from "./PageSectionListView.vue?vue&type=style&index=0&id=0ca48b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca48b74",
  null
  
)

export default component.exports